import ptBR from '../i18n/ptBR';
import enUS from '../i18n/enUS';
let currentLanguage = null;

export const setIdioma = (idioma) => {
    if(idioma != currentLanguage) {
        localStorage.setItem('idioma', idioma);
        currentLanguage = idioma;
        window.location.reload();
    }
}

export const translate = (key, options) => {
    var text = `[${key}]`;
    if(currentLanguage == null) {
        let _idioma = localStorage.getItem('idioma');
        if(_idioma)
            currentLanguage = _idioma;
    }
    if(currentLanguage == 'enUS' && enUS[key]) {
        text = enUS[key];
    } else if(ptBR[key]) {
        text = ptBR[key];
    }
    return text.replace(/\{(\d+)\}/g, (match, index) => {
      const idx = parseInt(index, 10);
      return (options && options[idx] !== undefined) ? options[idx] : match;
    });
};

export const isIdioma = (idioma) => currentLanguage == idioma;
export default translate;
